import { render, staticRenderFns } from "./TraceabilityModalStatus.vue?vue&type=template&id=9fa5907a"
import script from "./TraceabilityModalStatus.vue?vue&type=script&lang=js"
export * from "./TraceabilityModalStatus.vue?vue&type=script&lang=js"
import style0 from "./TraceabilityModalStatus.vue?vue&type=style&index=0&id=9fa5907a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports